module.exports = __webpack_public_path__ + "img/exchange-color@2x.87f24322.png";